/** The column the projects are filtered by access level, which is also its query param in the URL */
export const PROJECTS_ACCESS_LEVEL_FILTER_COLUMN = "accessLevel";

/** The column the projects are filtered by creation date, which is also its query param in the URL */
export const PROJECTS_CREATED_FILTER_COLUMN = "created";

/** The column the projects are filtered by size, which is also its query param in the URL */
export const PROJECTS_SIZE_FILTER_COLUMN = "size";

/** The columns the projects can be filtered by, in the order of their chips */
export const PROJECTS_FILTER_COLUMNS = [PROJECTS_ACCESS_LEVEL_FILTER_COLUMN, PROJECTS_CREATED_FILTER_COLUMN, PROJECTS_SIZE_FILTER_COLUMN];

/** The columns whose chips apply only one filter at a time */
export const PROJECTS_SINGLE_FILTER_COLUMNS = [PROJECTS_CREATED_FILTER_COLUMN, PROJECTS_SIZE_FILTER_COLUMN];

/** A column the projects can be filtered by */